import React, { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // This is where you will route the form data
    // Example: fetch('https://your-flask-api.com/send-email', { method: 'POST', body: JSON.stringify(formData) })
    console.log('Form data ready to route to backend:', formData);
    alert('Dummy form submitted! Check console for data.');
  };

  return (
    <div className="py-24 px-6 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row">
        
        {/* Contact Info Sidebar */}
        <div className="bg-blue-900 text-white p-10 md:w-2/5">
          <h2 className="text-3xl font-bold mb-6">Get in Touch</h2>
          <p className="text-blue-200 mb-10 leading-relaxed">
            We'd love to hear from you. Reach out to discuss infrastructure solutions or project opportunities.
          </p>
          <div className="space-y-4">
            <p><strong>Corporate Office:</strong><br/>IL&FS Water Limited<br/>Chennai, Tamil Nadu</p>
            <p><strong>Phone:</strong><br/>+91 44 4344 3345</p>
          </div>
        </div>

        {/* Dummy Form */}
        <div className="p-10 md:w-3/5">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Full Name</label>
              <input type="text" name="name" onChange={handleChange} required
                className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition" 
                placeholder="John Doe" />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Email Address</label>
              <input type="email" name="email" onChange={handleChange} required
                className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition" 
                placeholder="john@company.com" />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Subject</label>
              <input type="text" name="subject" onChange={handleChange} required
                className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition" 
                placeholder="Project Inquiry" />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Message</label>
              <textarea name="message" onChange={handleChange} required rows="4"
                className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition resize-none" 
                placeholder="How can we help you?"></textarea>
            </div>

            <button type="submit" 
              className="w-full bg-blue-600 text-white font-semibold py-3 rounded-md hover:bg-blue-700 transition">
              Send Message
            </button>
          </form>
        </div>
        
      </div>
    </div>
  );
}